<template>
	<div ref="loadMoreTrigger" class="table-load-placeholder">
		<div v-if="more" class="loading-spinner">
			<svg class="spinner" viewBox="0 0 50 50">
				<circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="3"></circle>
			</svg>
		</div>
	</div>
</template>

<script setup>
import { ref, watch, onBeforeUnmount, nextTick } from 'vue';

const props = defineProps({
	more: {
		type: Boolean,
		default: false
	}
});

const emit = defineEmits(['loadMore']);

const loadMoreTrigger = ref(null);
let observer = null;
let moreLoadingIng = false;

const setupIntersectionObserver = () => {
	const _observer = new IntersectionObserver(
		entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// 当元素进入视口时触发加载更多数据
					loadMoreData();
				}
			});
		},
		{ threshold: 0 }
	);

	// 开始观察指定的DOM元素
	if (loadMoreTrigger.value) {
		_observer.observe(loadMoreTrigger.value);
		observer = _observer;
	}
};

const loadMoreData = () => {
	if (!props.more) return;
	if (moreLoadingIng) return;
	moreLoadingIng = true;
	emit('loadMore', () => {
		moreLoadingIng = false;
	});
};

const destroy = () => {
	if (observer && loadMoreTrigger.value) {
		observer.unobserve(loadMoreTrigger.value);
		observer = null;
	}
};
onBeforeUnmount(() => {
	destroy();
});

// 监听 more 变化
watch(
	() => props.more,
	val => {
		destroy();
		if (val) {
			nextTick(() => {
				setupIntersectionObserver();
			});
		}
	},
	{ immediate: true }
);
</script>

<style lang="less" scoped>
@load-placeholder-padding: 18px;
@load-placeholder-size: 24px;

.table-load-placeholder {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: @load-placeholder-padding 0;
}

.loading-spinner {
	display: flex;
	align-items: center;
	justify-content: center;
}

.spinner {
	width: @load-placeholder-size;
	height: @load-placeholder-size;
	animation: rotate 1.4s linear infinite;
}

.path {
	stroke: rgba(var(--surf-inverse-color-rgb), 0.3);
	stroke-linecap: round;
	stroke-dasharray: 90, 150;
	stroke-dashoffset: 0;
	animation: dash 1.4s ease-in-out infinite;
}

@keyframes rotate {
	100% {
		transform: rotate(360deg);
	}
}

@keyframes dash {
	0% {
		stroke-dasharray: 1, 150;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 90, 150;
		stroke-dashoffset: -35;
	}
	100% {
		stroke-dasharray: 90, 150;
		stroke-dashoffset: -124;
	}
}
</style>
